import { Pipe, PipeTransform } from '@angular/core';
import { Batch } from '../../models';

@Pipe({
  name: 'batchReprint'
})
export class BatchReprintPipe implements PipeTransform {
  transform(batch: Batch): any {
    if (!batch) return false;

    return {
      reprint     : !!batch.compKey.match(/_R$/),
      colorReprint: batch.compKey.split('_').length === 5
    };
   /**
    * reprint        : !!batch.compKey.match(/_R$/),
      colorReprint   : batch.compKey.split('_').length === 5 */ 
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/batch-reprint.pipe.ts